import { Http, RequestOptions, Headers } from '@angular/http'
import { HttpClient } from '@angular/common/http'
import 'rxjs/add/operator/map'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '@angular/http/src/static_response'
import { timeout, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PostServiceM3 {
    idkatios: string
    servidor: string;
    servidorPersonas: string;
    servidorGenerales: string;
    servidorM3: string;
    servidorFEMX: string;
    servidorDocumentos: string;
    servidorContable: string;
    servidorPrestamo: string;
    WebBase: string;
    /*
    constructor(private http: Http, private httpClient: HttpClient) {
        //this.servidor= "http://yacuna.tecfinanzas.com:8084/WCFWE7Rest/";
        //this.servidor= "http://ticuna.tecfinanzas.com:8084/WCFWE7Rest/";
        //this.servidor= "http://ticuna.tecfinanzas.com/WCFWE7Rest/";
        //muisca
        //this.servidor= "http://muisca.tecfinanzas.com/WCFWE7Rest/";
        //var json = require('G:/Desarrollo/BD/WE8/config.json');
        var json = require('G:/Desarrollo/BD/WE8/config.json');
        this.servidorPersonas = json.ServidorPersonas;
        this.servidor = json.Servidor;
        this.servidorGenerales = json.ServidorGenerales;
        this.servidorM3 = json.ServidorM3;
        this.servidorDocumentos = json.ServidorDocumentos;
        this.servidorContable = json.ServidorContable;
        this.servidorPrestamo = json.ServidorPrestamo;
        this.WebBase = json.WebBase;
    }*/

        constructor(private http: Http, private httpClient: HttpClient) {
            //this.servidor= "http://yacuna.tecfinanzas.com:8084/WCFWE7Rest/";
            //this.servidor= "http://ticuna.tecfinanzas.com:8084/WCFWE7Rest/";
            //this.servidor= "http://ticuna.tecfinanzas.com/WCFWE7Rest/";
            //muisca
            //this.servidor= "http://muisca.tecfinanzas.com/WCFWE7Rest/";
            this.cargaInicial() ;
           
        }
    
        public cargaInicial(){
    
            var json =require('G:/Desarrollo/BD/WE8/config.json') ;
            let sConfigJSON = sessionStorage.getItem("ConfigJSON");
            console.log("constructor - sConfigJSON")
            console.log(sConfigJSON)
            if (sConfigJSON) {
                let jConfigJSON = JSON.parse(sConfigJSON);
                if(jConfigJSON.ServidorPersonas){
                    json = jConfigJSON;
                }
            }
            console.log("constructor - json")
            console.log(json)
            //var json = require('G:/Desarrollo/BD/WE8/config.json');
            this.servidorPersonas = json.ServidorPersonas;
            this.servidor = json.Servidor;
            this.servidorGenerales = json.ServidorGenerales;
            this.servidorM3 = json.ServidorM3;
            this.servidorFEMX = json.ServidorFEMX;
            this.servidorDocumentos = json.ServidorDocumentos;
            this.servidorContable = json.ServidorContable;
            this.servidorPrestamo = json.ServidorPrestamo;
            this.WebBase = json.WebBase;
        }
    

    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    async getConfigJson(idKatios: string) {
        try{
            let resp = await this.getWithBodyGenerales('Generales/getConfigJson/' + idKatios, null).toPromise();
            var respuesta: any = JSON.parse(resp.toString());
            this.respOk_getConfigJson(respuesta);
        }
        catch(err){
            console.log(err);
        }
    }

    respOk_getConfigJson(json){
        this.servidorPersonas = json.ServidorPersonas;
        this.servidor = json.Servidor;
        this.servidorGenerales = json.ServidorGenerales;
        this.servidorM3 = json.ServidorM3;
        this.servidorFEMX = json.ServidorFEMX;
        this.servidorDocumentos = json.ServidorDocumentos;
        this.servidorContable = json.ServidorContable;
        this.servidorPrestamo = json.ServidorPrestamo;
        this.WebBase = json.WebBase;
    }

    getURLServer() {
        return this.servidor;
    }

    getURLServerDocs() {
        return this.servidorDocumentos;
    }

    ///httpGet
    httpGet(urlGet: string, iServidor: string) {
        return this.http.get(iServidor + urlGet).map(res => {
            return res.json();
        });
    }


    ///httpGet
    httpGetWithTimeOut(urlGet: string, iServidor: string, timeoutTime: number) {
        return this.http.get(iServidor + urlGet).pipe(
            timeout(timeoutTime)
        ).map(res => {
            return res.json();
        });
    }

    httpGetWithBody(urlGet: string, iServidor: string, parametros: any) {
        const headers = new Headers();

        headers.append('Content-Type', 'application/json');


        //const options = new RequestOptions({headers: headers, body: {"correo": "params"}, params:myParams});

        return this.httpClient.get(iServidor + urlGet,
            {
                params: parametros
            }).map(res => {
                return res;
            });
    }

    httpGetWithBodyTimeOut(urlGet: string, iServidor: string, parametros: any, timeoutTime: number) {
        const headers = new Headers();

        headers.append('Content-Type', 'application/json');


        //const options = new RequestOptions({headers: headers, body: {"correo": "params"}, params:myParams});

        return this.httpClient.get(iServidor + urlGet,
            {
                params: parametros
            })
            .pipe(
                timeout(timeoutTime)
            )
            .map(res => {
                return res;
            });
    }

    http_get_blob(urlGet: string, iServidor: string, parametros: any) {
        const headers = new Headers();

        //headers.append('Content-Type', 'application/json');        
        //headers.append('Response Tyoe', 'blob');


        //const options = new RequestOptions({headers: headers, body: {"correo": "params"}, params:myParams});

        return this.httpClient.get(iServidor + urlGet,
            {
                responseType: "blob",
                params: parametros
            }).map(res => {
                return res;
            });
    }

    http_get_arraybuffer(urlGet: string, iServidor: string, parametros: any) {
        const headers = new Headers();

        //headers.append('Content-Type', 'application/json');        
        //headers.append('Response Tyoe', 'blob');


        //const options = new RequestOptions({headers: headers, body: {"correo": "params"}, params:myParams});

        return this.httpClient.get(iServidor + urlGet,
            {
                responseType: "arraybuffer",
                params: parametros
            }).map(res => {
                return res;
            });
    }



    getPrestamo(urlGet: string) {
        return this.httpGet(urlGet, this.servidorPrestamo);
    }

    public getWithBodyM3TimeOut(urlGet: string, params: any, timeoutTime: number) {
        return this.httpGetWithBodyTimeOut(urlGet, this.servidorM3, params, timeoutTime);
    }

    getWithBodyPrestamo(urlGet: string, params: any) {
        return this.httpGetWithBody(urlGet, this.servidorPrestamo, params);
    }

    public getWithBodyM3(urlGet: string, params: any) {
        return this.httpGetWithBody(urlGet, this.servidorM3, params);
    }

    getWithBodyPersonas(urlGet: string, params: any) {
        return this.httpGetWithBody(urlGet, this.servidorPersonas, params);
    }

    getWithBodyGenerales(urlGet: string, params: any) {
        return this.httpGetWithBody(urlGet, this.servidorGenerales, params);
    }

    getWithBodyDocumento(urlGet: string, params: any) {
        const headers = new Headers();

        //headers.append('Content-Type', 'application/json');
        headers.append('responseType', 'ResponseContentType.Blob');

        //const options = new RequestOptions({headers: headers, body: {"correo": "params"}, params:myParams});

        return this.httpClient.get(this.servidorDocumentos + urlGet,
            {
                params: params
            }).map(res => {
                return res;
            });

    }

    get_blob_Documentos(urlGet: string, params: any) {
        return this.http_get_blob(urlGet, this.servidorDocumentos, params);
    }

    get_arraybuffer_Documentos(urlGet: string, params: any) {
        return this.http_get_arraybuffer(urlGet, this.servidorDocumentos, params);
    }

    getPosts(urlGet: string) {
        return this.httpGet(urlGet, this.servidor);
    }

    getPersonas(urlGet: string) {
        return this.httpGet(urlGet, this.servidorPersonas);
    }

    getGenerales(urlGet: string) {
        return this.httpGet(urlGet, this.servidorGenerales);
    }

    getM3(urlGet: string) {
        return this.httpGet(urlGet, this.servidorM3);
    }

    getM3WithTimeOut(urlGet: string, timeOut: number) {
        return this.httpGetWithTimeOut(urlGet, this.servidorM3, timeOut);
    }




    getDocumentos(urlGet: string) {
        return this.httpGet(urlGet, this.servidorDocumentos);
    }


    getContable(urlGet: string) {
        return this.httpGet(urlGet, this.servidorContable);
    }
    ///End httpGet

    getPostsWithOutJson(urlGet: string) {
        return this.http.get(this.servidor + urlGet).map(res => {
            return res;
        });
    }


    postServiceHttp(urlGet: string, params) {
        return this.http.post(this.servidor + urlGet, params).map(
            res => {
                return res.statusText;
            }
        );
    }
    ///postServiceResponseHttp
    postServiceResponseHttp(urlGet: string, params) {
        return this.http.post(this.servidor + urlGet, params).map(res => {
            return res.json();
        });
    }

    postServiceResponseHttpCallService(urlGet: string, params, iServidor) {
        return this.http.post(iServidor + urlGet, params).map(res => {
            return res.json();
        });
    }
    postServiceResponseHttpPrestamos(urlGet: string, params) {
        return this.postServiceResponseHttpCallService(urlGet, params, this.servidorPrestamo);
    }
    ///End postServiceResponseHttp


    ///postServiceHttpOptions
    postServiceHttpOptionsCallService(urlGet: string, params, headers, iServidor) {
        let options = new RequestOptions({ headers: headers });

        return this.http.post(iServidor + urlGet, params, options).map(
            res => {
                return res;
            }
        );
    }

    postServiceHttpOptions(urlGet: string, params, headers) {
        return this.postServiceHttpOptionsCallService(urlGet, params, headers, this.servidor);
    }

    postServiceHttpOptionsM3(urlGet: string, params, headers) {
        return this.postServiceHttpOptionsCallService(urlGet, params, headers, this.servidorM3);
    }

    postServiceHttpOptionsDocs(urlGet: string, params, headers) {
        return this.postServiceHttpOptionsCallService(urlGet, params, headers, this.servidorDocumentos);
    }

    ///End postServiceHttpOptions

    ///postServiceHttpResFull
    postServiceHttpResFullCallService(urlGet: string, params, iServidor) {
        return this.http.post(iServidor + urlGet, params).map(
            res => {

                return res;
            }
        );
    }

    postServiceHttpResFull(urlGet: string, params) {
        return this.postServiceHttpResFullCallService(urlGet, params, this.servidor);
    }



    postServiceHttpResFullPersonas(urlGet: string, params) {
        return this.postServiceWebApi(urlGet, params, this.servidorPersonas);
    }

    postServiceHttpResFullM3(urlGet: string, params) {
        return this.postServiceWebApi(urlGet, params, this.servidorM3);
    }

    postServiceHttpResFullFEMX(urlGet: string, params) {
        return this.postServiceWebApi(urlGet, params, this.servidorFEMX);
    }

    postServiceHttpResFullGenerales(urlGet: string, params) {
        return this.postServiceHttpResFullCallService(urlGet, params, this.servidorGenerales);
    }

    postServiceHttpResFullPrestamos(urlGet: string, params) {
        return this.postServiceHttpResFullCallService(urlGet, params, this.servidorPrestamo);
    }
    ///End postServiceHttpResFull
    postServiceWebApi(urlGet: string, params, iServidor) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const options = new RequestOptions({ headers: headers });

        return this.http.post(iServidor + urlGet, params, options).map(
            res => {

                return res;
            }
        );
    }
}
